import { useRef, useState } from 'react';
import moment from 'moment';
import { SEND_TIMEOUT, STATUS } from '@v2/pages/productionOrder/modules/productionOrder/components/SendToImnoo/constants';

export const useManageSendToImnooButton = () => {
  const [status, setStatus] = useState<(typeof STATUS)[keyof typeof STATUS]>(STATUS.ACTIVE);
  const timestamp = useRef<string>();

  const onPress = () => {
    setStatus(STATUS.PENDING);
    setTimeout(() => {
      timestamp.current = moment().format('D-MMM-yyyy HH:mm');

      setStatus(STATUS.FINISHED);
    }, SEND_TIMEOUT);
  };

  return {
    status,
    timestamp,
    onPress,
  };
};
